import classnames from 'classnames';
import { PaymentMethodProps } from './PaymentMethod';
import Theme from '../../Theme';
import { Radio } from '@mui/material';
import React from 'react';
import usePaymentFlow from '../../../hooks/payment/usePaymentFlow';
import FeedbackLabel from '../../labels/FeedbackLabel';
import { useTranslation } from 'react-i18next';
import useOrderFlow from '../../../hooks/order/useOrderFlow';

export default function PaymentMethodOption(props: PaymentMethodProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Payment:PaymentMethods:PaymentMethodOption' });

  const { name, id, extra, isSelected, isDisabled, onClick, children, className } = props;

  const { localData } = useOrderFlow();
  const { isPaymentMethodDisabled } = usePaymentFlow();

  const globallyDisabled = isPaymentMethodDisabled(id);
  const disabled = isDisabled || globallyDisabled;

  return (
    <div>
      <div
        className={classnames(
          'w-full p-sm cursor-pointer transition-colors ease-in-out delay-150 duration-300 border has-[:checked]:bg-blue-200 dark:has-[:checked]:bg-black-100 has-[:checked]:border-blue-300 dark:has-[:checked]:border-brand-border',
          className,
        )}
        onClick={disabled ? null : onClick}
      >
        <div className={classnames({ 'opacity-35': globallyDisabled })}>
          <div className="flex justify-between gap-lg">
            <div className="flex">
              <Radio
                checked={isSelected}
                sx={{
                  color: Theme.color.blue['300'],
                  '&.Mui-checked': {
                    color: Theme.color.blue['300'],
                  },
                }}
                className="my-auto"
              />
              <p className="ml-sm my-auto text-sm">{name}</p>
            </div>
            {extra}
          </div>
          {globallyDisabled && (
            <FeedbackLabel
              type="Notice"
              className="mt-sm"
              textClassname="text-xs my-auto"
              message={t('feedback.payment_method_disabled', {
                paymentMethod: name,
                orderMethod: t(`order_methods.${localData.method}`),
              })}
            />
          )}
        </div>
      </div>
      {children}
    </div>
  );
}
